import React from "react";
import { Link } from "react-router-dom";

export default function HomeNav() {
  return (
    <div className="homenav text-center">
      <div className="container">
        <div className="row">
          <div className="col-2">
            <Link to="/AllMobile">
              <img
                src="https://rukminim1.flixcart.com/flap/128/128/image/22fddf3c7da4c4f4.png?q=100"
                alt=""
              />
              <br></br>
              <h6>Mobile</h6>
            </Link>
          </div>
          <div className="col-2">
            <Link to="/AllGrocery">
              <img
                src="https://rukminim1.flixcart.com/flap/128/128/image/29327f40e9c4d26b.png?q=100"
                alt=""
              />
              <br></br>
              <h6>Grocery</h6>
            </Link>
          </div>
          <div className="col-2">
            <Link to="/AllFashion">
              <img
                src="https://rukminim1.flixcart.com/flap/128/128/image/82b3ca5fb2301045.png?q=100"
                alt=""
              />
              <br></br>
              <h6>Fashion</h6>
            </Link>
          </div>
          <div className="col-2">
            <Link to="/AllTelevision">
              <img
                src="https://rukminim1.flixcart.com/flap/128/128/image/0ff199d1bd27eb98.png?q=100"
                alt=""
              />
              <br></br>
              <h6>Appliance</h6>
            </Link>
          </div>
          <div className="col-2">
            <Link to="/AllHomeAppliances">
              <img
                src="https://rukminim1.flixcart.com/flap/128/128/image/ee162bad964c46ae.png?q=100"
                alt=""
              />
              <br></br>
              <h6>Home Decors</h6>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
